import React from 'react';
import './ShopifyMerchant.scss';

// Sin «Volver al Shopify App Store» (tanda 23/10, `copy.md` §4): la app pública de Dashbo no está publicada
// todavía, así que el link no llevaba a ningún lado útil en ninguno de los dos caminos (la app pública y la
// app personalizada del link de instalación).
export default function ShopifyMerchantSuccess() {
    const params = new URLSearchParams(window.location.search);
    const agencyName = params.get('agency_name') || 'tu agencia';
    const shopSubdomain = params.get('shop') || '';

    return (
        <div className="merchant-install-page">
            <div className="merchant-install-card">
                <img
                    src="/logo-light.svg"
                    alt="Dashbo"
                    className="merchant-install-logo"
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
                <div className="merchant-install-checkmark" aria-hidden="true">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                        <circle cx="32" cy="32" r="30" fill="#7CB502"/>
                        <path d="M20 33L28 41L44 23" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h1>¡Tu tienda está conectada!</h1>
                <p>
                    {shopSubdomain ? <strong>{shopSubdomain}.myshopify.com</strong> : 'Tu tienda'} quedó vinculada a <strong>{agencyName}</strong>.
                </p>
                <p>Tu agencia ya puede ver tus datos para armar reportes. Ya podés cerrar esta ventana.</p>
            </div>
        </div>
    );
}
